module.exports = __webpack_public_path__ + "img/Complaints.1bd0c12a.svg";